import { __awaiter, __generator, __values } from "tslib";
import { UnimplementedError } from '@tencent/memoire-error-utils';
import { CollectionMonitorEvent, EngineAction, EngineMonitorEvent } from './monitor-event';
import { BEGIN } from './constants';
/**
 * Make a type-safe enumerable tuple
 * @param items String literals
 * @returns a type-safe string tuple
 */
function StringTuple() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return items;
}
/**
 * A monitor plugin to capture all events of storage.
 *
 * It's common to be used for performance reporting
 */
var MonitorPlugin = /** @class */ (function () {
    /**
     * @example
     * Here's an example to report events to a reporter.
     * ```
     * new StructuredStorage({
     *   ...,
     *   plugins: [
     *      new MonitorPlugin({
     *        onEvent(e) {
     *          reportPerformance(e.module, e.action, e.cost, e.status > 0)
     *        }
     *      })
     *   ]
     * })
     * ```
     */
    function MonitorPlugin(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.disabled, disabled = _c === void 0 ? false : _c, onEvent = _b.onEvent, onCollectionEvent = _b.onCollectionEvent, onEngineEvent = _b.onEngineEvent;
        this.name = 'MonitorPlugin';
        this.begin = function (ctx) {
            ctx.timings.set(BEGIN, new Date());
        };
        this.reportReadEvent = function (ctx, action) {
            _this.reportCollectionEvent(ctx, action, function (event) { return __awaiter(_this, void 0, void 0, function () {
                var ret, isNotFound;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!ctx.return) return [3 /*break*/, 2];
                            return [4 /*yield*/, ctx.return];
                        case 1:
                            ret = _a.sent();
                            isNotFound = action === 'has' ? !ret : ret === null;
                            event.increment('read', isNotFound ? 0 : 1);
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        };
        this.reportBatchReadEvent = function (ctx, action) {
            _this.reportCollectionEvent(ctx, action, function (event) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!ctx.return) return [3 /*break*/, 2];
                            _b = (_a = event).increment;
                            _c = ['read'];
                            return [4 /*yield*/, ctx.return];
                        case 1:
                            _b.apply(_a, _c.concat([(_d.sent()).length]));
                            _d.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        };
        this.reportWriteEvent = function (ctx, action) {
            _this.reportCollectionEvent(ctx, action, function (event) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!ctx.return) return [3 /*break*/, 2];
                            _b = (_a = event).increment;
                            _c = ['write'];
                            return [4 /*yield*/, ctx.return];
                        case 1:
                            _b.apply(_a, _c.concat([(_d.sent()) === null ? 0 : 1]));
                            _d.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        };
        this.reportBatchWriteEvent = function (ctx, action) {
            _this.reportCollectionEvent(ctx, action, function (event) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!ctx.return) return [3 /*break*/, 2];
                            _b = (_a = event).increment;
                            _c = ['write'];
                            return [4 /*yield*/, ctx.return];
                        case 1:
                            _b.apply(_a, _c.concat([(_d.sent()).length]));
                            _d.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        };
        this.reportDeleteEvent = function (ctx, action) {
            _this.reportCollectionEvent(ctx, action, function (event) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!ctx.return) return [3 /*break*/, 2];
                            _b = (_a = event).increment;
                            _c = ['delete'];
                            return [4 /*yield*/, ctx.return];
                        case 1:
                            _b.apply(_a, _c.concat([(_d.sent()) === null ? 0 : 1]));
                            _d.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        };
        this.reportBatchDeleteEvent = function (ctx, action) {
            _this.reportCollectionEvent(ctx, action, function (event) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!ctx.return) return [3 /*break*/, 2];
                            _b = (_a = event).increment;
                            _c = ['delete'];
                            return [4 /*yield*/, ctx.return];
                        case 1:
                            _b.apply(_a, _c.concat([(_d.sent()).length]));
                            _d.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        };
        this.disabled = disabled;
        this.onEvent = onEvent;
        this.onCollectionEvent = onCollectionEvent;
        this.onEngineEvent = onEngineEvent;
    }
    MonitorPlugin.prototype.register = function (storage) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
        var _this = this;
        if (this.disabled)
            return;
        var _e = storage.aspects, collection = _e.collection, engine = _e.engine;
        var _loop_1 = function (action) {
            collection[action].before(this_1.begin).after(function (ctx) { return _this.reportReadEvent(ctx, action); });
        };
        var this_1 = this;
        try {
            /**
             * Monitor for Single Read
             */
            for (var _f = __values(StringTuple('get', 'has', 'first', 'last')), _g = _f.next(); !_g.done; _g = _f.next()) {
                var action = _g.value;
                _loop_1(action);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var _loop_2 = function (action) {
            collection[action].before(this_2.begin).after(function (ctx) { return _this.reportBatchReadEvent(ctx, action); });
        };
        var this_2 = this;
        try {
            /**
             * Monitor for Batch Read
             */
            for (var _h = __values(StringTuple('entries', 'keys', 'values', 'update')), _j = _h.next(); !_j.done; _j = _h.next()) {
                var action = _j.value;
                _loop_2(action);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var _loop_3 = function (action) {
            collection[action].before(this_3.begin).after(function (ctx) { return _this.reportWriteEvent(ctx, action); });
        };
        var this_3 = this;
        try {
            /**
             * Monitor for Single Write
             */
            for (var _k = __values(StringTuple('upsert', 'insert')), _l = _k.next(); !_l.done; _l = _k.next()) {
                var action = _l.value;
                _loop_3(action);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var _loop_4 = function (action) {
            collection[action].before(this_4.begin).after(function (ctx) { return _this.reportBatchWriteEvent(ctx, action); });
        };
        var this_4 = this;
        try {
            /**
             * Monitor for Batch Write
             */
            for (var _m = __values(StringTuple('bulkUpsert', 'bulkInsert', 'update')), _o = _m.next(); !_o.done; _o = _m.next()) {
                var action = _o.value;
                _loop_4(action);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            }
            finally { if (e_4) throw e_4.error; }
        }
        /**
         * Monitor for Delete
         */
        collection.delete.before(this.begin).after(function (ctx) { return _this.reportDeleteEvent(ctx, 'delete'); });
        /**
         * Monitor for Batch Delete
         */
        collection.clear.before(this.begin).after(function (ctx) { return _this.reportBatchDeleteEvent(ctx, 'clear'); });
        /**
         * Monitor for engine
         */
        engine.openDB.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.engineOpenDB); });
        engine.deleteDB.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.engineDeleteDB); });
        var database = engine.database, table = engine.table, transaction = engine.transaction, index = engine.index, cursor = engine.cursor;
        /**
         * Monitor for database
         */
        database.close.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.databaseClose); });
        database.createTable
            .before(this.begin)
            .after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.databaseCreateTable); });
        database.deleteTable
            .before(this.begin)
            .after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.databaseDeleteTable); });
        /**
         * Monitor for table
         */
        table.get.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableGet); });
        table.getAll.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableGetAll); });
        table.getAllKeys.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableGetAllKeys); });
        table.insert.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableInsert); });
        table.upsert.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableUpsert); });
        table.delete.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableDelete); });
        table.clear.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableClear); });
        table.bulkDelete.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableBulkDelete); });
        table.bulkUpsert.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableBulkUpsert); });
        table.query.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableQuery); });
        table.createIndex.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableCreateIndex); });
        table.deleteIndex.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.tableDeleteIndex); });
        /**
         * Monitor for transaction
         */
        transaction.commit.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.transactionCommit); });
        transaction.rollback
            .before(this.begin)
            .after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.transactionRollback); });
        /**
         * Monitor for index
         */
        index.get.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.indexGet); });
        index.getAll.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.indexGetAll); });
        index.getAllKeys.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.indexGetAllKeys); });
        /**
         * Monitor for cursor
         */
        cursor.delete.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.cursorDelete); });
        cursor.update.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.cursorUpdate); });
        cursor.next.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.cursorNext); });
        cursor.value.before(this.begin).after(function (ctx) { return _this.reportEngineEvent(ctx, EngineAction.cursorValue); });
    };
    MonitorPlugin.prototype.dispose = function (storage) {
        throw new UnimplementedError({ storage: storage });
    };
    MonitorPlugin.prototype.reportEngineEvent = function (ctx, action) {
        var _a, _b;
        var begin = ctx.timings.get(BEGIN) || new Date();
        var cost = Date.now() - begin.getTime();
        var event = new EngineMonitorEvent(action, cost);
        if (ctx.error) {
            event.markError(ctx.error);
        }
        (_a = this.onEvent) === null || _a === void 0 ? void 0 : _a.call(this, event);
        (_b = this.onEngineEvent) === null || _b === void 0 ? void 0 : _b.call(this, event);
    };
    MonitorPlugin.prototype.reportCollectionEvent = function (ctx, action, writeStats) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var begin, cost, event;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        begin = ctx.timings.get(BEGIN) || new Date();
                        cost = Date.now() - begin.getTime();
                        event = new CollectionMonitorEvent(action, cost);
                        if (!ctx.error) return [3 /*break*/, 1];
                        event.error(ctx.error);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, writeStats(event, ctx)];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        (_a = this.onEvent) === null || _a === void 0 ? void 0 : _a.call(this, event);
                        (_b = this.onCollectionEvent) === null || _b === void 0 ? void 0 : _b.call(this, event);
                        return [2 /*return*/];
                }
            });
        });
    };
    return MonitorPlugin;
}());
export default MonitorPlugin;
//# sourceMappingURL=monitor-plugin.js.map